<template>
  <div class="work-box">
    <div class="bg-box">
      <img class="bg-img" src="/images/bg.png" alt="">
      <div class="bg-title">Come shopping with me ZEBRO</div>
    </div>
    <div class="logo-box">
      <img :src="logoImg" />
    </div>
    <div class="title-box">
      <span class="title-name">Zebro APP</span>
    </div>
    <div  class="download-now">
      Download Now
    </div>
    <div class="btn-box">
      <div class="btn-item btn-android" @click="goAndroid">
        <img :src="androidImg" />
        <span>Android</span>
      </div>
      <div class="btn-item btn-ios" @click="goIos">
        <img :src="iosImg" />
        <!-- <span>请到苹果商店搜索“易得国际易货”下载安装</span> -->
         <span>Apple Store</span>
      </div>
      <div class="btn-item btn-google" @click="goGoogle">
        <img :src="googleImg" />
        <!-- <span>请到苹果商店搜索“易得国际易货”下载安装</span> -->
         <span>Google Paly</span>
      </div>
    </div>
    <div class="tipWarp" :class="{'tipWarp-close': !iswechat}">
      <div class="tipWarp-mask"></div>
      <img class="wxtip-icon" :src="tipImg" />
      <p class="wxtip-txt">点击右上角<br/>选择在浏览器中打开</p>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      logoImg: './images/logo.png',
      androidImg: './images/android.png',
      iosImg: './images/ios.png',
      googleImg: './images/google.png',
      tipImg: './images/tip.png',
      iswechat: true,
      androidDownloadUrl: 'http://zebraapk.weihaimingchuang.com',
      iosDownloadUrl: 'https://apps.apple.com/us/app/zebra-shopping/id1585128571',
      googleDownloadUrl: 'https://play.google.com/store/apps/details?id=com.mzs.freshgo'
    }
  },
  mounted () {
    this.iswechat = this.getBowerState()
  },
  methods: {
    goAndroid () {
      window.location = this.androidDownloadUrl
    },
    goIos () {
      window.location = this.iosDownloadUrl
    },
    goGoogle () {
      window.location = this.googleDownloadUrl
    },
    getBowerState () {
      let ua = window.navigator.userAgent.toLowerCase()
      let result = ua.match(/MicroMessenger/i)
      if (!result) {
        return false
      } else if (result[0] && result[0] === 'micromessenger') {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style scoped>
  .work-box{
    position: relative;
    height: 100vh;
    height: 100dvh;
  }
  .bg-box{
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: auto;
  }
  .bg-img{
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
    width: 100%;
    height: auto;
  }
  .bg-title{
    position: absolute;
    z-index: 2;
    bottom: 24px;
    left: 0;
    right: 0;
    text-align: center;
    font-weight: normal;
    font-size: 14px;
    color: #FFFFFF;
  }
  .logo-box{
    position: relative;
    display: flex;
    justify-content: center;
    padding-top: 25%;
  }
  .logo-box img{
    display: block;
    width: 84px;
    height: 84px;
    border-radius: 12px;
    box-shadow: 0px 3px 6px 1px rgba(243,58,34,0.19);
  }
  .title-box{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 6px;
    color: #000000;
    font-weight: bold;
    font-size: 18px;
  }
  .title-box .title-version{
    margin-left: 8px;
    color: #FF0000;
  }
  .download-now{
    padding: 42px 0 11px;
    font-weight: 400;
    font-size: 12px;
    color: #535353;
    text-align: center;
  }
  .btn-box{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .btn-item{
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    padding-left: 30px;
    width: 188px;
    height: 48px;
    background: #90C83B;
    border-radius: 4px;
  }
  .btn-item img{
    margin-right: 15px;
    width: 24px;
    padding: 10px 0;
  }
  .btn-item span{
    color: #ffffff;
    font-size: .34rem;
  }
  .btn-ios{
    /* padding:  0 50px; */
    background: #000000;
  }
  .btn-google{
    /* padding:  0 50px; */
    background: #388EF1;
  }
  .btn-ios img{
    flex-shrink: 0;
  }
  .tipWarp{
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 999;
  }
  .tipWarp-close{
    display: none;
  }
  .tipWarp .tipWarp-mask{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #000;
    opacity: 0.8;
  }
  .wxtip-txt{
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 2rem;
    color: #fff;
    z-index: 3;
    text-align: center;
  }
  .wxtip-icon{
    position: absolute;
    top: 20px;
    right: 20px;
    width: 50px;
    z-index: 3;
  }
  /* 平板端样式 (屏幕宽度 ≥ 768px) */
@media screen and (min-width: 460px) {
 .bg-box{
  display: none;
 }
}
</style>
